import {
    KNOWLEDGE_ITEM_RESPONSE,
    KNOWLEDGE_ITEM_SAVE_RESPONSE,
    MODERATION_FEED_ITEM_RESPONSE,
    MODERATION_FEED_ITEM_SAVE_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { authorToUI } from "../../models/entities/feed"

export default (state = {}, action) => {
    const { type, data } = action
    switch (type) {
        case KNOWLEDGE_ITEM_SAVE_RESPONSE:
        case KNOWLEDGE_ITEM_RESPONSE:
        case MODERATION_FEED_ITEM_RESPONSE:
        case MODERATION_FEED_ITEM_SAVE_RESPONSE:
            return {
                ...state,
                ...(data.authors || [])
                    .map(authorToUI)
                    .reduce((newState, author) => {
                        return {
                            ...newState,
                            [author.id]: author
                        }
                    }, {})
            }
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
